(function () {
  var RESTORES = [
    ['Powered by Odustajanjely - EU withdrawal button compliance', 'Powered by Withdrawly - EU withdrawal button compliance'],
    ['Odustajanjely', 'Withdrawly'],
  ];

  var TRANSLATIONS = [
    ['Contact us', 'Kontaktirajte nas!'],
    ['Foma za odustajanje od porudžbine', 'Obrazac za odustajanje od narudžbe'],
    ['Forma za odustajanje od porudžbine', 'Obrazac za odustajanje od narudžbe'],
    [
      'Leave your message here and we will reply to you shortly.',
      'Ostavite svoju poruku i odgovorit ćemo Vam u najkraćem mogućem roku.',
    ],
    ['Short text', 'Poruka'],
    ['ID porudžbine', 'ID (broj #) narudžbe'],
    [
      'Zahtev za odustajanje od porudžbine je uspešno poslat',
      'Vaš zahtjev za odustajanje od narudžbe je uspješno poslan!',
    ],
    [
      'Zahtjev za odustajanje od porudžbine je uspješno poslan',
      'Vaš zahtjev za odustajanje od narudžbe je uspješno poslan!',
    ],
    ['Your withdrawal request has been submitted', 'Vaš zahtjev za odustajanje od narudžbe je uspješno poslan!'],
    ['Withdrawal request submitted', 'Vaš zahtjev za odustajanje od narudžbe je uspješno poslan!'],
    [
      'Your withdrawal request has been submitted successfully',
      'Vaš zahtjev za odustajanje od narudžbe je uspješno poslan!',
    ],
    [
      'Thank you! Your withdrawal request has been received.',
      'Vaš zahtjev za odustajanje od narudžbe je uspješno poslan!',
    ],
    ['Send', 'Pošalji'],
    ['Cancel an item', 'Obrazac za odustajanje od narudžbe'],
    [
      'Look up your order, choose the items, and submit a withdrawal request.',
      'Pronađite narudžbu, odaberite artikle i pošaljite zahtjev za odustajanje.',
    ],
    ['Continue', 'Nastavi'],
    ['Find your order', 'Pronađite narudžbu'],
    ['Use the order number from your confirmation email.', 'Koristite broj narudžbe iz e-maila potvrde.'],
    ['Name', 'Ime'],
    ['Email', 'E-pošta'],
    ['E-mail', 'E-pošta'],
    ['Order number', 'Broj narudžbe'],
    ['Order ID', 'ID (broj #) narudžbe'],
    ['Right of withdrawal', 'Odustajanje od narudžbe'],
    ['Withdraw items', 'Odustajanje od narudžbe'],
    ['Withdrawal items', 'Odustajanje od narudžbe'],
    ['1 Look up', '1 Pronađite narudžbu'],
    ['2 Choose items', '2 Odaberite artikle'],
    ['Look up', 'Pronađite narudžbu'],
    ['Choose items', 'Odaberite artikle'],
    ['3 Confirm', '3 Potvrda'],
    ['Confirm', 'Potvrdi'],
    ['Back', 'Natrag'],
    ['Submit withdrawal', 'Pošalji zahtjev'],
    ['Select items to withdraw', 'Odaberite artikle za odustajanje'],
    ['Review your withdrawal', 'Pregledajte zahtjev za odustajanje'],
    ['Order not found', 'Narudžba nije pronađena'],
    [
      'Double-check the number and email. They need to match what you used at checkout.',
      'Provjerite broj narudžbe i e-mail. Moraju se podudarati s podacima korištenim pri narudžbi.',
    ],
  ];

  function applyTranslations(value) {
    if (!value) return value;
    var updated = value;
    for (var r = 0; r < RESTORES.length; r++) {
      if (updated.indexOf(RESTORES[r][0]) !== -1) {
        updated = updated.split(RESTORES[r][0]).join(RESTORES[r][1]);
      }
    }
    if (updated.indexOf('Withdrawly') !== -1) return updated;
    var sorted = TRANSLATIONS.slice().sort(function (a, b) {
      return b[0].length - a[0].length;
    });
    for (var i = 0; i < sorted.length; i++) {
      var en = sorted[i][0];
      var hr = sorted[i][1];
      if (updated.indexOf(en) !== -1) {
        updated = updated.split(en).join(hr);
      }
    }
    return updated;
  }

  function translateAttributes(el) {
    ['placeholder', 'aria-label', 'title', 'value'].forEach(function (attr) {
      if (!el.hasAttribute(attr)) return;
      var current = el.getAttribute(attr);
      var next = applyTranslations(current);
      if (next !== current) el.setAttribute(attr, next);
    });
  }

  function translateNode(root) {
    if (!root || root.nodeType !== 1) return;

    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        if (!node.textContent.trim()) return NodeFilter.FILTER_REJECT;
        var parent = node.parentElement;
        if (!parent || parent.tagName === 'SCRIPT' || parent.tagName === 'STYLE') {
          return NodeFilter.FILTER_REJECT;
        }
        return NodeFilter.FILTER_ACCEPT;
      },
    });

    var textNode;
    while ((textNode = walker.nextNode())) {
      var original = textNode.textContent;
      var translated = applyTranslations(original);
      if (translated !== original) textNode.textContent = translated;
    }

    if (root.nodeType === 1) {
      translateAttributes(root);
      root.querySelectorAll('[placeholder], [aria-label], [title], input[type="submit"], input[type="button"]').forEach(
        translateAttributes
      );
    }
  }

  var scheduled = false;
  function scheduleTranslate() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      translateNode(document.body);
    });
  }

  function boot() {
    scheduleTranslate();
    new MutationObserver(scheduleTranslate).observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
